(function () {
    /* ================================
      CONFIG
    ================================ */
    // Default URL (fallback)
    //const DEFAULT_RAKUTEN_JOIN_URL = 'https://www.rakuten.com/canvvs_24591-xfas';
    const DEFAULT_RAKUTEN_JOIN_URL = 'https://spa60-web.app.link/e/arqhsDR0F0b';

    // Get URL from data attribute if available
    function getRakutenUrl() {
        const redirectInput = document.querySelector('input[data-rakuten-redirect="true"]');
        if (redirectInput && redirectInput.dataset.rakutenUrl) {
            return redirectInput.dataset.rakutenUrl;
        }
        
        return DEFAULT_RAKUTEN_JOIN_URL;
    }

    // Require at least ONE of these params on the URL to validate return
    const REQUIRED_PARAMS_ANY = [
        'ranMID',
        'ranEAID',
        'ranSiteID',
        '_branch_match_id',
        '_branch_referrer'
    ];
    const REQUIRED_UTM_SOURCE_VALUE = 'RAN'; // accept utm_source=RAN as well

    const KEYS = {
        joined: 'rakuten_joined',
        pending: 'rakuten_pending',
        token: 'rakuten_token',
        currentUrlClick: 'current_url_click'
    };

    /* ================================
      STORAGE HELPERS
    ================================ */
    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) { } }
    function del(k) { try { localStorage.removeItem(k); } catch (e) { } }

    function hasJoined() {
        return get(KEYS.joined) === '1';
    }

    /* ================================
      TOKEN GENERATOR (stored only)
    ================================ */
    function generateToken() {
        try {
            const b = new Uint8Array(16);
            crypto.getRandomValues(b);
            return Array.from(b).map(x => x.toString(16).padStart(2, '0')).join('');
        } catch (e) {
            return Date.now().toString(16) + Math.random().toString(16).slice(2);
        }
    }

    /* ================================
      RAKUTEN PARAM CHECK (CURRENT URL)
    ================================ */
    function hasRakutenParamsOnUrl() {
        const url = new URL(window.location.href);

        const hasAny = REQUIRED_PARAMS_ANY.some(p => url.searchParams.has(p));
        const utmSource = (url.searchParams.get('utm_source') || '').toUpperCase();
        const utmOk = utmSource ? (utmSource === REQUIRED_UTM_SOURCE_VALUE) : false;

        return hasAny || utmOk;
    }

    /* ================================
      OPTIONAL: CLEAN URL AFTER SUCCESS
    ================================ */
    function cleanRakutenParamsFromUrl() {
        const url = new URL(window.location.href);

        REQUIRED_PARAMS_ANY.forEach(p => url.searchParams.delete(p));

        const utmSource = (url.searchParams.get('utm_source') || '').toUpperCase();
        if (utmSource === REQUIRED_UTM_SOURCE_VALUE) {
            url.searchParams.delete('utm_source');
            url.searchParams.delete('utm_medium');
            url.searchParams.delete('utm_campaign');
            url.searchParams.delete('utm_content');
        }

        // (If you want to keep the params for analytics attribution, remove this function call below.)
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    /* ================================
      VALIDATE ON RETURN
      Conditions:
      - pending=1 (they attempted ATC and we redirected them)
      - token exists in localStorage (unique per browser session)
      - Rakuten params exist on URL
      This prevents copy/paste URLs from validating on fresh browsers.
    ================================ */
    function validateReturn() {
        if (hasJoined()) {
            // Check if we're on the stored URL and clean it up
            const storedUrl = get(KEYS.currentUrlClick);
            if (storedUrl && window.location.href === storedUrl) {
                del(KEYS.currentUrlClick);
                console.log('[Rakuten] cleaned up stored URL');
            }
            return;
        }

        const pending = get(KEYS.pending) === '1';
        const tokenStored = get(KEYS.token);

        // Must be from our flow
        if (!pending || !tokenStored) return;

        // Must have Rakuten params present on URL
        if (hasRakutenParamsOnUrl()) {
            set(KEYS.joined, '1');
            del(KEYS.pending);
            del(KEYS.token);

            // Optional: remove params after validation
            cleanRakutenParamsFromUrl();

            console.log('[Rakuten] validated: params + stored token');
            
            // Redirect to stored URL if available
            const storedUrl = get(KEYS.currentUrlClick);
            if (storedUrl) {
                console.log('[Rakuten] redirecting to stored URL');
                window.location.href = storedUrl;
            }
        } else {
            // Came back without params → do not validate; allow retry
            del(KEYS.pending);
            del(KEYS.token);
            console.log('[Rakuten] missing params — still locked');
        }
    }

    // Run validation on load/return (BFCache-safe)
    window.addEventListener('pageshow', validateReturn);
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') validateReturn();
    });

    /* ================================
      REDIRECT TO RAKUTEN (on ATC)
      - generate token
      - set pending
      - go to rakuten in same tab
    ================================ */
    let redirecting = false;

    function redirectToRakuten() {
        if (hasJoined()) return;
        if (redirecting) return;

        // Check if redirect is enabled via data attribute
        const redirectInput = document.querySelector('input[data-rakuten-redirect="true"]');
        if (!redirectInput) {
            // Redirect not enabled for this form, allow normal ATC
            return;
        }

        redirecting = true;

        set(KEYS.pending, '1');
        set(KEYS.token, generateToken());

        const redirectUrl = redirectInput.dataset.rakutenUrl || getRakutenUrl();
        
        // Store current URL if redirecting to DEFAULT_RAKUTEN_JOIN_URL
        if (redirectUrl === DEFAULT_RAKUTEN_JOIN_URL) {
            set(KEYS.currentUrlClick, window.location.href);
        }
        
        window.location.assign(redirectUrl); // same tab
    }

    /* ================================
      BLOCK ADD TO CART (UI)
    ================================ */
    function isAddToCartTrigger(target) {
        return !!target.closest(
            'form[action*="/cart/add"], button[name="add"], [type="submit"][name="add"], .product-form__submit, .add-to-cart, [data-add-to-cart]'
        );
    }

    function isRakutenRedirectEnabled(form) {
        if (!form) return false;
        return !!form.querySelector('input[data-rakuten-redirect="true"]');
    }

    document.addEventListener('click', function (e) {
        if (!isAddToCartTrigger(e.target)) return;
        if (hasJoined()) return;

        const form = e.target.closest('form');
        if (!isRakutenRedirectEnabled(form)) return;

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        redirectToRakuten();
    }, true);

    document.addEventListener('submit', function (e) {
        const form = e.target;
        if (!form) return;

        const isATC = (form.action && form.action.includes('/cart/add')) || form.querySelector('input[name="id"]');
        if (!isATC) return;
        if (hasJoined()) return;
        if (!isRakutenRedirectEnabled(form)) return;

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        redirectToRakuten();
    }, true);

    /* ================================
      BLOCK AJAX /cart/add(.js) (AJAX-proof)
    ================================ */
    function isCartAddUrl(u) {
        const s = String(u || '');
        return s.includes('/cart/add');
    }

    if (window.fetch) {
        const _fetch = window.fetch.bind(window);
        window.fetch = function (input, init) {
            const url = (typeof input === 'string') ? input : (input && input.url) || '';
            if (!hasJoined() && isCartAddUrl(url)) {
                // Check if any form has rakuten redirect enabled
                const hasRedirectEnabled = document.querySelector('input[data-rakuten-redirect="true"]');
                if (hasRedirectEnabled) {
                    redirectToRakuten();
                    return Promise.reject(new Error('Rakuten gate blocked add-to-cart'));
                }
            }
            return _fetch(input, init);
        };
    }

    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
        this.__rakuten_url = url;
        return _open.apply(this, arguments);
    };
    const _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
        if (!hasJoined() && isCartAddUrl(this.__rakuten_url)) {
            // Check if any form has rakuten redirect enabled
            const hasRedirectEnabled = document.querySelector('input[data-rakuten-redirect="true"]');
            if (hasRedirectEnabled) {
                redirectToRakuten();
                try { this.abort(); } catch (e) { }
                return;
            }
        }
        return _send.apply(this, arguments);
    };

})();